export const syncPageSizeQueryLimit = (criteria = {}, collectionConfig = {}, pageSize) => {
	const limit = collectionConfig?.limit;
	const numericPageSize = Number(pageSize);
	if (!Number.isFinite(limit) || limit <= 0 || !Number.isFinite(numericPageSize) || numericPageSize <= 0) {
		return criteria;
	}
	if (criteria.limit === numericPageSize) return criteria;
	return { ...criteria, limit: numericPageSize };
};
